import { apiRequest } from './api';

const TMDB_GENRES = [
    { id: 28,    name: 'Action' },
    { id: 12,    name: 'Adventure' },
    { id: 16,    name: 'Animation' },
    { id: 35,    name: 'Comedy' },
    { id: 80,    name: 'Crime' },
    { id: 99,    name: 'Documentary' },
    { id: 18,    name: 'Drama' },
    { id: 10751, name: 'Family' },
    { id: 14,    name: 'Fantasy' },
    { id: 36,    name: 'History' },
    { id: 27,    name: 'Horror' },
    { id: 10402, name: 'Music' },
    { id: 9648,  name: 'Mystery' },
    { id: 10749, name: 'Romance' },
    { id: 878,   name: 'Science Fiction' },
    { id: 53,    name: 'Thriller' },
    { id: 10752, name: 'War' },
    { id: 37,    name: 'Western' },
    { id: 10759, name: 'Action & Adventure' },
    { id: 10762, name: 'Kids' },
    { id: 10765, name: 'Sci-Fi & Fantasy' },
    { id: 10768, name: 'War & Politics' },
];

export const OnboardingService = {
    // Quiz-ready picker: page 1 leads with titles that already have a stored
    // question pool, and every page excludes titles that would fail the
    // release / season gates at quiz start.
    getPopularTitles(page = 1) {
        return apiRequest(`/onboarding/titles?page=${page}`, { authenticated: false });
    },

    searchTitles(q, page = 1) {
        return apiRequest(`/media/search?q=${encodeURIComponent(q)}&page=${page}`, { authenticated: false });
    },

    getGenres() {
        return Promise.resolve({ genres: TMDB_GENRES });
    },

    // Post-first-coin "What do you want to watch next?" grid. Page 1 is the
    // ranked 12; later pages are more trending titles for infinite scroll.
    // exclude: [{ tmdbId, kind }] — the title just verified (also excluded server-side).
    getWatchlistSuggestions(exclude = [], page = 1) {
        const params = new URLSearchParams();
        const param = exclude
            .filter((e) => e?.tmdbId && (e.kind === 'movie' || e.kind === 'tv'))
            .map((e) => `${e.kind}:${e.tmdbId}`)
            .join(',');
        if (param) params.set('exclude', param);
        if (page > 1) params.set('page', String(page));
        const qs = params.toString();
        return apiRequest(`/onboarding/watchlist-suggestions${qs ? `?${qs}` : ''}`);
    },

    // Continue / Skip for the Watchlist step. Idempotent server-side.
    completeWatchlistOnboarding({ skipped = false, itemsAddedCount = 0 } = {}) {
        return apiRequest('/onboarding/watchlist/complete', {
            method: 'POST',
            body: { skipped, itemsAddedCount },
        });
    },

    // watchedTitles: [{ tmdbId, kind }]
    complete(watchedTitles, genreIds = []) {
        return apiRequest('/onboarding', {
            method: 'POST',
            body: { watchedTitles, genreIds },
        });
    },
};